export const namespaced = true;

export const state = {
  modelFieldName: null,
  prevRouteName: null,
  prevFormData: null,
  childFieldNames: [],
  excludeItems: {},
};

export const mutations = {
  SAVE_FORM_DATA(state, { modelFieldName, formData, prevRouteName, childFieldNames, excludeItems }) {
    state.modelFieldName = modelFieldName;
    state.prevFormData = formData;
    state.prevRouteName = prevRouteName;
    state.childFieldNames = childFieldNames;
    state.excludeItems = excludeItems;
  },
  SET_MODEL_FIELD_NAME(state, data) {
    state.prevFormData[state.modelFieldName] = data;
  },
  CLEAR_CHILD_FIELDS_DATA(state) {
    if (Array.isArray(state.childFieldNames)) {
      state.childFieldNames.forEach((fieldName) => {
        state.prevFormData[fieldName] = null;
      });
    }
  },
  CLEAR_FORM_DATA_STORED(state) {
    state.prevFormData = null;
    state.prevRouteName = null;
    state.childFieldNames = [];
    state.excludeItems = {};
  },
};

export const actions = {
  storeFormData({ commit }, { modelFieldName, formData, prevRouteName, childFieldNames, excludeItems }) {
    commit('SAVE_FORM_DATA', { modelFieldName, formData, prevRouteName, childFieldNames, excludeItems });
  },
  setModelFieldName({ commit }, data) {
    commit('SET_MODEL_FIELD_NAME', data);
    commit('CLEAR_CHILD_FIELDS_DATA');
  },
  clearFormDataStored({ commit, state }) {
    if (state.prevFormData) {
      commit('CLEAR_FORM_DATA_STORED');
    }
  },
};
